<aside
  class="p-4 rounded-md top-5 max-h-[100vh] sticky bg-white shadow hidden lg:block"
>
  <div class="flex items-center justify-between mb-5">
    <h2 class="text-lg font-semibold">Filtros</h2>
    <button
      (click)="clearFilters()"
      class="border border-primary text-primary px-3 py-1 rounded hover:border-primary hover:text-primary cursor-pointer w-fit"
    >
      Limpiar filtros
    </button>
  </div>
  <section class="mb-6 bg-white">
    <h3 class="font-medium mb-2">Fecha de publicación</h3>
    <div class="flex flex-col space-y-2">
      <label
        *ngFor="let f of fechas"
        class="inline-flex items-center cursor-pointer"
      >
        <input
          type="checkbox"
          class="text-primary"
          [checked]="selectedFechaValue === f.value"
          (change)="onSelectFecha(f.value)"
        />
        <span class="ml-2 text-gray-700">{{ f.label }}</span>
      </label>
    </div>
  </section>
  <section class="mb-6">
    <h3 class="font-medium mb-2">Nivel académico</h3>
    <app-input-select
      placeholder="Todos los niveles"
      [control]="filtersForm.get('idEducation')"
      [options]="modalidades"
      [showError]="false"
    ></app-input-select>
  </section>
  <section class="mb-6">
    <h3 class="font-medium mb-2">Área</h3>
    <app-input-select
      placeholder="Todas las áreas"
      [control]="filtersForm.get('idArea')"
      [options]="areas"
      [showError]="false"
    ></app-input-select>
  </section>
  <section class="mb-6">
    <h3 class="font-medium mb-2">Experiencia requerida</h3>
    <app-input-select
      placeholder="Todos"
      [control]="filtersForm.get('minimumExperience')"
      [options]="experiencias"
      [showError]="false"
    ></app-input-select>
  </section>
  <div
    *ngIf="loading"
    class="absolute inset-0 bg-white/70 flex items-center justify-center z-10 pointer-events-auto"
  ></div>
</aside>
